import {fetchGet, fetchPost} from "../../util/FetchUtil";



class UserDataService {

    constructor({contextRoot, ipstackUrl}){
        this.contextRoot = contextRoot;
        this.ipstackUrl = ipstackUrl;
        this.createPath = this.createPath.bind(this);
        this.checkPremiumPhone = this.checkPremiumPhone.bind(this);
        this.sendMessageToPhone = this.sendMessageToPhone.bind(this);
        this.resendPhoneVerificationCode = this.resendPhoneVerificationCode.bind(this);
        this.convertExternalToCgl = this.convertExternalToCgl.bind(this);
        this.saveExternalProfile = this.saveExternalProfile.bind(this);
        this.saveMiniExternalProfile = this.saveMiniExternalProfile.bind(this);
        this.findCountries = this.findCountries.bind(this);
        this.findCountryByIp = this.findCountryByIp.bind(this);
        this.findStatesByCountryCode = this.findStatesByCountryCode.bind(this);
        this.findPostalCodesByCountry = this.findPostalCodesByCountry.bind(this);
        this.findCityStatesByPostalCode = this.findCityStatesByPostalCode.bind(this);
        this.findLocation = this.findLocation.bind(this);
        this.sendCodeToEmail = this.sendCodeToEmail.bind(this);
        this.verifyPhoneCode = this.verifyPhoneCode.bind(this);
        this.verifyEmailCodeAndPassword = this.verifyEmailCodeAndPassword.bind(this);
        this.getDuoAuthUrl = this.getDuoAuthUrl.bind(this);
        this.clearDuoSession = this.clearDuoSession.bind(this);
        this.checkDuoAuthenticationStatus = this.checkDuoAuthenticationStatus.bind(this);
    }

    createPath(path){
        return this.contextRoot + "/userupdate/" + path + ".action";
    }

    checkPremiumPhone({countryCode, phoneNumber}){
        return fetchPost({
            path: this.createPath("checkPremiumPhone"),
            body: JSON.stringify({countryCode, phoneNumber})
        });
    }

    sendMessageToPhone(data){
        return fetchPost({
            path: this.createPath("sendMessageToPhone"),
            body: JSON.stringify(data)
        });
    }

    resendPhoneVerificationCode(){
        return fetchPost({
            path: this.createPath("resendPhoneVerificationCode"),
            body: "{}"
        });
    }

    verifyPhoneCode({code}){
        return fetchPost({
            path: this.createPath("verifyPhoneCode"),
            body: JSON.stringify({code})
        });
    }

    cancelPhoneVerification(){
        return fetchPost({
            path: this.createPath("cancelPhoneVerification")
        });
    }

    toPremiumCgl(obj) {
        return fetchPost({
            path: this.createPath("toPremiumCgl"),
            body: JSON.stringify(obj)
        });
    }

    convertExternalToCgl(obj) {
        return fetchPost({
            path: this.createPath("convertExternalToCgl"),
            body: JSON.stringify(obj)
        });
    }

    saveExternalProfile(obj) {
        return fetchPost({
            path: this.createPath("saveExternalProfile"),
            body: JSON.stringify(obj)
        });
    }

    saveMiniExternalProfile(obj) {
        return fetchPost({
            path: this.createPath("saveMiniExternalProfile"),
            body: JSON.stringify(obj)
        });
    }

    getDuoInitData(){
        return fetchGet({
            path: this.createPath("getDuoInitData")
        });
    }

    findCalcs({password, userName, firstName, lastName}){
        return fetchPost({
            path: this.createPath("findCalcs"),
            body: JSON.stringify({password, userName, firstName, lastName})
        })
    }

    findCountryByIp(){
        if (this.ipstackUrl) {   // necessary for SSO, not My Profile
            return fetch("https:" + this.ipstackUrl, {
                method: "GET",
                headers: { Accept: 'application/json' }
            })
        } else {
            return Promise.resolve();
        }
    }

    findCountries() {
        return fetchGet({
            path: this.createPath("findCountries")
        });
    }

    findStatesByCountryCode({country = ''}) {
        const queryParams = "?country=" + encodeURIComponent(validator.trim(country));
        return fetchGet({
            path: this.createPath("findStates") + queryParams,
        });
    }

    findPostalCodesByCountry({countryCode = '', input = ''}) {
        const pageNumber = 1, pageSize = 100;
        const queryParams =
            "?countryCode=" + (encodeURIComponent(validator.trim(countryCode))) +
            "&postalCode=" + (input) +
            "&pageNumber=" + pageNumber +
            "&pageSize=" + pageSize;

        return fetchGet({
            path: this.createPath("findPostalCodes") + queryParams,
        });
    }

    findCityStatesByPostalCode({postalCode = ''}) {
        const queryParams = "?postalCode=" + encodeURIComponent(validator.trim(postalCode));
        return fetchGet({
            path: this.createPath("findCityStates") + queryParams,
        });
    }

    findLocation({country, postalCode}) {
        return fetchPost({
            path: this.createPath("findLocation"),
            body: JSON.stringify({country, postalCode})
        });
    }

    createUser(data){
        return fetchPost({
            path: this.contextRoot + "/register/createUser",
            body: JSON.stringify(data)
        })
    }

    isEmailUsedAndInactive(data){
        return fetchPost({
            path: this.contextRoot + "/userupdate/isEmailUsedAndInactive",
            body: data
        })
    }

    isEmailUserNameUsed(data){
        return fetchPost({
            path: this.contextRoot + "/userupdate/isEmailUserNameUsed",
            body: data
        })
    }

    sendCodeToEmail({email}) {
        return fetchPost({
            path: this.createPath("sendCodeToEmail"),
            body: JSON.stringify({email})
        });
    }

    verifyEmailCodeAndPassword({code, password}) {
        return fetchPost({
            path: this.createPath("verifyEmailCodeAndPassword"),
            body: JSON.stringify({code, password})
        });
    }

    getIPStack(){
        return fetchGet({
            path: '//api.ipstack.com/check?access_key=3eb36ffebd8f7347322bcc632b501561',
            addHeaders: false
        })
    }

    getDuoAuthUrl(){
        return fetchGet({
            path: this.contextRoot + "/duo/getDuoAuthUrl.action",
        })
    }

    clearDuoSession(queryParams){
        return fetchGet({
            path: this.contextRoot + "/duo/clearDuoSession.action" + queryParams,
        })
    }

    checkDuoAuthenticationStatus(queryParams){
        return fetchGet({
            path: this.contextRoot + "/duo/checkDuoAuthenticationStatus.action" + queryParams,
        })
    }
}

export default UserDataService;